import theme from '../theme/theme';

export const containerStyles = {
  position: 'relative',
  py: 10,
  minHeight: '500px',
  backgroundImage: `url(${process.env.PUBLIC_URL}/assets/contact_banner.jpg)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  color: '#fff',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    bgcolor: 'rgba(0,0,0,0.4)',
    zIndex: 1,
  },
};

export const headingStyles = {
  mb: 6,
  fontSize: { xs: '2rem', sm: '3rem', md: '3.8rem' },
  fontWeight: 700,
  lineHeight: 1.15,
  color: 'common.white',
  textShadow: '0 2px 4px rgba(0,0,0,0.4)',
};

export const gridStyles = {
  display: 'grid',
  gap: 5,
  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
  alignItems: 'start',
};

export const glassStyles = {
  p: 5,
  backgroundColor: 'rgba(255, 255, 255, 0.15)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  borderRadius: 4,
  border: '1px solid rgba(255, 255, 255, 0.3)',
  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.1)',
  color: theme.palette.text.primary,
  height: '100%',
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export const textFieldStyles = {
  '& .MuiInputBase-root': {
    color: 'white',
  },
  '& .MuiInput-underline:before': {
    borderBottomColor: 'rgba(255, 255, 255, 0.5)',
  },
  '& .MuiInput-underline:hover:before': {
    borderBottomColor: 'white',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.palette.primary.main,
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.7)',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'white',
  },
};

export const buttonStyles = {
  borderRadius: '999px',
  px: 5,
  py: 1.75,
  fontWeight: 700,
  fontSize: '1rem',
};

export const contactInfoStyles = {
  display: 'flex',
  alignItems: 'center',
  mb: 3,
  color: 'common.white',
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
};

export const iconStyles = {
  mr: 2,
  color: theme.palette.primary.main,
};

export const dividerStyles = {
  my: 4,
  bgcolor: 'rgba(255,255,255,0.3)',
};

export const infoTextStyles = {
  color: 'rgba(255,255,255,0.8)',
};
